'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendTeamEnquiry = exports.previewUpcomingInvoice = exports.updateSubscription = exports.createSubscription = exports.deleteSubscription = exports.updateCustomer = exports.getCustomer = exports.getPlans = exports.getCoupon = undefined;

var _http = require('../../../utils/services/http');

var _httpConstants = require('../../../../common/utils/http/httpConstants');

var getCoupon = exports.getCoupon = function getCoupon(_ref) {
    var couponCode = _ref.couponCode;
    return (0, _http.http)({
        url: 'payments/coupons/' + couponCode
    });
};

var getPlans = exports.getPlans = function getPlans(_ref2) {
    var volume = _ref2.volume;
    return (0, _http.http)({
        url: 'payments/plans',
        params: {
            volume: volume
        }
    });
};

var getCustomer = exports.getCustomer = function getCustomer(_ref3) {
    var customerId = _ref3.customerId;
    return (0, _http.http)({ url: 'payments/customers/' + customerId });
};

var updateCustomer = exports.updateCustomer = function updateCustomer(_ref4) {
    var customerId = _ref4.customerId,
        token = _ref4.token;
    return (0, _http.http)({
        url: 'payments/customers/' + customerId,
        method: _httpConstants.METHODS.PUT,
        timeout: 10000,
        data: {
            token: token
        }
    });
};

var deleteSubscription = exports.deleteSubscription = function deleteSubscription(_ref5) {
    var subscriptionId = _ref5.subscriptionId;
    return (0, _http.http)({
        url: 'payments/subscriptions/' + subscriptionId,
        method: _httpConstants.METHODS.DELETE,
        timeout: 30000
    });
};

var createSubscription = exports.createSubscription = function createSubscription(_ref6) {
    var token = _ref6.token,
        planInterval = _ref6.planInterval,
        coupon = _ref6.coupon,
        prorateDate = _ref6.prorateDate,
        memberIds = _ref6.memberIds;
    return (0, _http.http)({
        url: 'payments/subscriptions',
        method: _httpConstants.METHODS.POST,
        data: {
            token: token,
            planInterval: planInterval,
            coupon: coupon,
            prorateDate: prorateDate,
            memberIds: memberIds
        },
        timeout: 30000
    });
};

var updateSubscription = exports.updateSubscription = function updateSubscription(_ref7) {
    var subscriptionId = _ref7.subscriptionId,
        planInterval = _ref7.planInterval,
        coupon = _ref7.coupon,
        prorateDate = _ref7.prorateDate,
        memberIds = _ref7.memberIds;
    return (0, _http.http)({
        url: 'payments/subscriptions/' + subscriptionId,
        method: _httpConstants.METHODS.PUT,
        data: {
            planInterval: planInterval,
            coupon: coupon,
            prorateDate: prorateDate,
            memberIds: memberIds
        },
        timeout: 30000
    });
};

var previewUpcomingInvoice = exports.previewUpcomingInvoice = function previewUpcomingInvoice(_ref8) {
    var subscriptionId = _ref8.subscriptionId,
        customerId = _ref8.customerId,
        planInterval = _ref8.planInterval,
        coupon = _ref8.coupon,
        prorateDate = _ref8.prorateDate,
        memberIds = _ref8.memberIds;
    return (0, _http.http)({
        url: 'payments/subscriptions/' + subscriptionId + '/preview',
        method: _httpConstants.METHODS.GET,
        params: {
            customerId: customerId,
            memberIds: memberIds,
            planInterval: planInterval,
            coupon: coupon,
            prorateDate: prorateDate
        },
        timeout: 5000
    });
};

var sendTeamEnquiry = exports.sendTeamEnquiry = function sendTeamEnquiry(_ref9) {
    var email = _ref9.email;
    return (0, _http.http)({
        url: 'payments/subscriptions/teams/enquire',
        method: _httpConstants.METHODS.POST,
        data: {
            email: email
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/paymentService.js
// module id = 753
// module chunks = 0